import { Users, Settings2, Wallet } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useLang } from "@/context/LangContext";
import { UsersTable } from "@/components/admin/UsersTable";
import { SettingsPanel } from "@/components/admin/SettingsPanel";
import { PaymentReviews } from "@/components/admin/PaymentReviews";

export default function AdminDashboard() {
  const { t } = useLang();
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-12 lg:py-14" data-testid="admin-dashboard">
      <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">{t("admin_title")}</h1>
      <p className="mt-2 text-muted-foreground">{t("admin_subtitle")}</p>
      <Tabs defaultValue="payments" className="mt-8">
        <TabsList className="h-auto flex-wrap justify-start rounded-3xl p-1">
          <TabsTrigger value="payments" className="gap-2 rounded-full px-5 py-2" data-testid="admin-tab-payments"><Wallet className="h-4 w-4" />{t("tab_payments")}</TabsTrigger>
          <TabsTrigger value="users" className="gap-2 rounded-full px-5 py-2" data-testid="admin-tab-users"><Users className="h-4 w-4" />{t("tab_users")}</TabsTrigger>
          <TabsTrigger value="settings" className="gap-2 rounded-full px-5 py-2" data-testid="admin-tab-settings"><Settings2 className="h-4 w-4" />{t("tab_settings")}</TabsTrigger>
        </TabsList>
        <TabsContent value="payments" className="mt-6"><PaymentReviews /></TabsContent>
        <TabsContent value="users" className="mt-6"><UsersTable /></TabsContent>
        <TabsContent value="settings" className="mt-6"><SettingsPanel /></TabsContent>
      </Tabs>
    </div>
  );
}
